
export class PageResult<A> {
  items: A[];
  offset: string;
}
